import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { lastValueFrom } from 'rxjs';
import { WoundCareWidgetService } from '../wound-care-widget.service';
import { calculateWeekDifference } from '../wound-utils'

import * as moment from 'moment';
import { WoundService } from 'src/app/services/wound.service';

function getRandom(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}




@Component({
  selector: 'app-wound-care-widget-wound-list',
  templateUrl: './wound-care-widget-wound-list.component.html',
  styleUrls: ['./wound-care-widget-wound-list.component.css']
})
export class WoundCareWidgetWoundListComponent implements OnInit {

  woundsLoaderId = 'woundsLoaderId' + Math.random()

  @Input() patient;
  @Input() provider;
  @Input() note;
  @Input() woundState: string;
  @Input() readOnlyMode: any;
  @Input() isPreview;
  @Output() onICDsSave: EventEmitter<any> = new EventEmitter();
  @Output() woundAnalyticReport: EventEmitter<any> = new EventEmitter();
  @Output() woundDetailsChange: EventEmitter<any> = new EventEmitter();
  @Output() woundCountChange: EventEmitter<any> = new EventEmitter();

  wounds: any[] = [];
  constructor(
    private loader: NgxUiLoaderService,
    private woundCareWidgetService: WoundCareWidgetService,
    private _woundService: WoundService,
  ) {
  }

  ngOnInit(): void {
    this.initWounds();
  }

  initDummyWounds() {

    this.wounds = Array.from({ length: 4 }).map((e, i: number) => ({
      woundNo: (i + 1),
      wod: new Date(),
      wound_images: [
        `https://picsum.photos/seed/${Math.random()}/200/200`,
        `https://picsum.photos/seed/${Math.random()}/200/200`,
        `https://picsum.photos/seed/${Math.random()}/200/200`,
        `https://picsum.photos/seed/${Math.random()}/200/200`,
        `https://picsum.photos/seed/${Math.random()}/200/200`,
        `https://picsum.photos/seed/${Math.random()}/200/200`,
        `https://picsum.photos/seed/${Math.random()}/200/200`,
        `https://picsum.photos/seed/${Math.random()}/200/200`,
      ],
      body_side: 'Left',
      etiolgy: 'Suprior',
      body_oart: 'Leg',
      wound_type: 'Pressure',
      stage: '1',
      length: 4,
      width: 3,
      depth: 2,

      state: this.woundState,
      parent_wound: true,

      child_wounds: Array.from({ length: getRandom(1, 5) }).map((e, i) => ({
        woundNo: (i + 1),
        wound_image: `https://picsum.photos/seed/${Math.random()}/200/200`,
        dos: new Date(),
        stage: '1',
        length: 4,
        width: 3,
        state: this.woundState,
        depth: 2,
      }))

    }));
  }

  async initWounds() {
    this.loader.startLoader(this.woundsLoaderId);
    const { status, data } = await lastValueFrom(this.woundCareWidgetService.getWounds(this.patient._id, this.woundState));
    console.log("data + status", data, status)
    if (status == 200) {
      // .map(this._identifyMostRecentWound)
      if(this.woundState === "active"){
        let today = new Date();
        let todaydate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        const parentWoundstoChangeState =  this.checkOldWoundsandUpdateState(data);
        const filteredWounds = data.filter((wound)=> !parentWoundstoChangeState.includes(wound._id.toString()));
        if(parentWoundstoChangeState.length > 0){
          this.wounds = filteredWounds.map(this._sortParentWithChildWounds);
          this._woundService.changeWoundsStatewithPatientId({wound_ids: parentWoundstoChangeState , state: 'remission', remission_Date: todaydate}).subscribe();
          this.woundCountChange.emit({activecount: filteredWounds.length, archivedcount: parentWoundstoChangeState.length});
        }else{
          this.wounds = data.map(this._sortParentWithChildWounds);
        }
      }else{
        this.wounds = data.map(this._sortParentWithChildWounds);
      }

    }
    this.loader.stopLoader(this.woundsLoaderId);
  }

  filterWounds(wounds, woundState) {
    return wounds.filter(wound => {
      return wound.state === woundState

    })
  }

  private _sortWounds = (wounds, order = -1) => {
    return wounds.slice().sort((a, b) => {
      // normalize
      let aCreatedAt, bCreatedAt;
      if (a.createdAt.match(/^\d+\/\d+\/\d+$/m)) {
        // prase MM/DD/YYYY using moment
        aCreatedAt = moment(a.createdAt, 'MM/DD/YYYY').toDate()
      } else {
        aCreatedAt = new Date(a.createdAt)
      }
      if (b.createdAt.match(/^\d+\/\d+\/\d+$/m)) {
        bCreatedAt = moment(b.createdAt, 'MM/DD/YYYY').toDate()
      } else {
        bCreatedAt = new Date(b.createdAt)
      }

      if (order < 0) {
        return new Date(bCreatedAt).getTime() - new Date(aCreatedAt).getTime()
      } else {
        return new Date(aCreatedAt).getTime() - new Date(bCreatedAt).getTime()
      }
    });
  }
  private _sortParentWithChildWounds = (parentWithChildWounds) => {
    const { latest_child_wound, ...parentWound } = parentWithChildWounds;
    // flatten
    const [newParentWound, ...latestChildWound] = this._sortWounds([parentWound, ...parentWithChildWounds.latest_child_wound], -1);
    newParentWound.latest_child_wound = latestChildWound;
    // maintain parent wound state
    newParentWound.state = parentWound.state;
    return newParentWound;
  }
  private _identifyMostRecentWound(parentWithChildWounds) {
    const { latest_child_wound, ...parentWound } = parentWithChildWounds;
    if (latest_child_wound.length > 0) {
      latest_child_wound[0]._most_recent_wound = true;
    } else {
      parentWound._most_recent_wound = true;
    }
    parentWound.latest_child_wound = latest_child_wound;
    return parentWound;
  }
  removeWoundfromList(wound: any) {
    this.wounds = this.wounds.filter(wounds => {
      if (wounds.latest_child_wound.length > 0) {
        if (wounds.latest_child_wound[0]._id != wound._id) {
          return wounds;
        }
      } else {
        if (wounds._id != wound) {
          return wounds
        }
      }
    });
  }
  updateWoundfromNote(id, data) {
    console.log(this.wounds,id, data);
    this.wounds.forEach((wound) => {
      if (!wound.parent_wound) {
        if (wound._id === id) {
          for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
              const value = data[key];
              wound[key] = value;
            }
          }
          return;
        }
      } else {
        wound.latest_child_wound.forEach((latestWound) => {
          if (latestWound._id === id) {
            for (const key in data) {
              if (Object.prototype.hasOwnProperty.call(data, key)) {
                const value = data[key];
                latestWound[key] = value;
              }
            }
            console.log(latestWound);
            return;
          }
        })
      }
    });
  }
  handleICDsSave(icds) {
    console.log('wound-care-widget-wound-list > handleICDsSave')
    this.onICDsSave.emit(icds);
  }
  handleWoundDetailsChange(data) {
    this.woundDetailsChange.emit(data);
  }
  selectedWound: any;
  showWoundReport(wound) {
    for(let woundObj of this.wounds) {
      if(woundObj.latest_child_wound.length > 0){
       if(woundObj.latest_child_wound[0]._id == wound._id) {
          woundObj.latest_child_wound[0].isSelected = true;
        }
        if(this.selectedWound) {
          if(this.selectedWound._id == woundObj.latest_child_wound[0]._id) {
            woundObj.latest_child_wound[0].isSelected = false;
          }
        } 
      }
      else {
        if(wound._id == woundObj._id) {
          woundObj.isSelected = true;
        }
        if(this.selectedWound) {
          if(this.selectedWound._id == woundObj._id) {
            woundObj.isSelected = false;
          }
        }
      }
      
      
    }
    this.selectedWound = wound;
    this.woundAnalyticReport.emit(wound);
  }
  checkOldWoundsandUpdateState(wounds){
    const allParentWounds = wounds.filter((w)=> w.parent_wound == null);
    const allParentWoundswithWeekDiff = allParentWounds.map((w)=> { return {id: w._id, difference: calculateWeekDifference(w), wound_updation_date: w.wound_updation_date}});
    const parentWoundstoChangeState = allParentWoundswithWeekDiff.filter((w)=> !w.wound_updation_date || w.difference >= 8);
    return parentWoundstoChangeState.map((w)=> w.id)
  }
}
